
export default 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
//# sourceMappingURL=gif.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/media/gif.js
// module id = 19
// module chunks = 0 1